export const QUIZ_QUERY_PARAMS = {
  MOTIVATION_REFINEMENT_VIEWED: 'mr', // Key for tracking if the motivation refinement (Category selection) step was viewed
  SELECTED_CATEGORIES: 'categories', // Key for storing selected categories
  SELECTED_SUBCATEGORIES: 'subcategories', // Key for storing selected subcategories
  SKIP_Q1: 'wq', // Key for indicating if the first question should be skipped (user comes from the home hero quiz)
  WAS_VIEWED: 't', // Value for indicating if something was viewed
  SPRINGBOARD_ITEM_ID: 'sp_id', // Key for storing the UUID of the clicked springboard item (pen-5453_v1 & pen-5557_v1)
  SPRINGBOARD_ITEM_TYPE: 'sp_t', // Key for storing the type of the clicked springboard item (pen-5453_v1 & pen-5557_v1)
} as const
